<template>
  <b-card
    no-body
    class="card-revenue-budget"
  >
    <b-row class="mx-0">
      <b-col
        md="8"
        class="revenue-report-wrapper"
      >
        <div class="d-sm-flex align-items-center mb-3" style="margin-bottom: 0 !important;">
          <h4 class="card-title mb-50 mb-sm-0">
            {{ title }}
          </h4>
        </div>

        <!-- chart -->
        <vue-apex-charts
          type="bar"
          height="180"
          :options="barChartOptions"
          :series="barChartSeries"
        />
      </b-col>

      <b-col
        md="4"
        class="budget-wrapper align-self-center"
      >
        <b-avatar
          class="mb-1"
          :variant="variant"
          size="75"
          style="margin-bottom: 0.5em !important;"
        >
          <feather-icon
            size="38"
            :icon="icon"
          />
        </b-avatar>
        <h4 class="mb-25">
          {{ currentValue }} {{ unity }}
        </h4>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BAvatar
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

export default {
  components: {
    VueApexCharts,
    BCard,
    BRow,
    BCol,
    BAvatar
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    currentValue: {
      type: [String, Number],
      required: true,
    },
    axisX: {
      type: Array,
      required: true,
    },
    axisY: {
      type: Array,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    unity: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      default: 'light-info',
    },
    color: {
      type: String,
      default: 'info',
    },
  },
  computed: {
    barChartSeries() {
      return [
        {
          name: this.title,
          data: this.axisY,
        },
      ]
    },
    calculateColumnWidth() {
      const dataLength = this.axisX.length
      if (dataLength === 0) return '55%'
      
      // Define largura mínima para evitar colunas muito largas quando há poucos dados
      // Calcula a largura baseada na quantidade de dados
      const minWidthPercent = 15 // Mínimo de 15% para evitar colunas muito largas
      const maxWidthPercent = 55 // Máximo de 55% para muitos dados
      
      // Ajusta a largura baseado na quantidade de dados
      if (dataLength <= 3) {
        return `${minWidthPercent}%`
      } else if (dataLength <= 6) {
        return `${Math.max(minWidthPercent, 100 / dataLength * 0.8)}%`
      } else {
        return `${maxWidthPercent}%`
      }
    },
    barChartOptions() {
      const colorMap = {
        info: $themeColors.info,
        warning: $themeColors.warning,
        danger: $themeColors.danger,
        success: $themeColors.success,
        primary: $themeColors.primary,
      }
      
      const chartColor = colorMap[this.color] || $themeColors.info

      return {
        chart: {
          type: 'bar',
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        colors: [chartColor],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: this.calculateColumnWidth,
            barHeight: '100%',
            endingShape: 'rounded',
            borderRadius: 4,
            dataLabels: {
              position: 'top',
            },
          },
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758'],
          },
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        grid: {
          xaxis: {
            lines: {
              show: false,
            },
          },
        },
        xaxis: {
          categories: this.axisX,
          labels: {
            rotate: -45,
            rotateAlways: false,
            style: {
              fontSize: '11px',
            },
          },
        },
        yaxis: {
          title: {
            text: this.unity,
            style: {
              fontSize: '12px',
            },
          },
        },
        fill: {
          opacity: 0.8,
        },
        tooltip: {
          y: {
            formatter: (val) => {
              const unit = this.unity ? ` ${this.unity}` : ''
              return `${val}${unit}`
            },
          },
        },
      }
    },
  },
}
</script>

<style>
.card-revenue-budget .revenue-report-wrapper {
  padding: 1.2rem 1rem 0rem 1rem;
}
</style>

